import { Button, Modal } from 'antd';
import moment from 'moment-timezone';
import React from 'react';
import { DATETIMEWITHBRACKET } from '../../../../common/constants';

const AlreadyRespondedModal = ({ showModal, setShowModal, data }) => {
  return (
    <Modal
      id="already-responded-modal"
      maskClosable={false}
      centered
      open={showModal}
      className="import-modal"
      footer={null}
      closable={false}
      onCancel={() => setShowModal(false)}
      destroyOnHidden
    >
      <h2 className="mb-25" id="already-responded-title">
        Issue already responded
      </h2>
      <div id="already-responded-message">
        {`${data?.responder?.name} has already responded to this issue on ${
          data?.respondedOn &&
          moment(data?.respondedOn)
            ?.tz(data?.instructionData?.project?.timeZone)
            ?.format(DATETIMEWITHBRACKET)
        }.`}
      </div>
      <div className="form-buttons mt-25" id="already-responded-buttons">
        <Button
          id="already-responded-ok-button"
          shape="round"
          className="save-button"
          type="primary"
          onClick={() => setShowModal(false)}
        >
          Ok
        </Button>
      </div>
    </Modal>
  );
};

export default AlreadyRespondedModal;
